export enum WidgetCode {
  Redmine = 'redmine',
}

export type SupportWidgetConfig<ConfigType> = {
  script: string,
  config: ConfigType,
}

export type RedmineConfig = {
  color?: string,
  translation?: {
    nameLabel?: string,
    emailLabel?: string,
    subjectLabel?: string,
    descriptionLabel?: string,
    attachmentLinkLabel?: string,
    createButtonLabel?: string,
    createSuccessLabel?: string,
    createSuccessDescription?: string,
    createErrorLabel?: string,
  },
  identify?: {
    nameValue?: string,
    emailValue?: string,
    subjectValue?: string,
    trackerValue?: string,
    projectValue?: string,
    customFieldValues?: {
      [key: string]: string
    },
  },
}

export type SupportHeaderBarItemData = {
  widget: WidgetCode | null,
  widgets: {
    [WidgetCode.Redmine]: SupportWidgetConfig<RedmineConfig>,
  },
}
